
.emc,
.emc *,
.emc *::before,
.emc *::after {
  box-sizing: border-box;
}

.emc {
  position: relative;
  background: #ffffff;
  color: #0a0a0a;
  font-family: "Rajdhani", Arial, sans-serif;
  overflow: hidden;
  padding: clamp(2.5rem, 5vw, 4.5rem) clamp(1rem, 4vw, 2rem);
}

.emc-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
  align-items: center;
  column-gap: clamp(1.75rem, 4vw, 3.5rem);
}

.emc-media {
  display: flex;
  align-items: center;
  justify-content: center;
}

.emc-image {
  display: block;
  width: 100%;
  height: auto;
  max-height: 520px;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(10, 10, 10, 0.08),
    0 1px 2px rgba(10, 10, 10, 0.04);
  border: 1px solid rgba(10, 10, 10, 0.06);
}

.emc-content {
  max-width: 560px;
}

.emc-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #de3431;
  margin-bottom: 1.5rem;
}

.emc-eyebrow-mark {
  width: 28px;
  height: 2px;
  background: #de3431;
  border-radius: 2px;
  display: inline-block;
}

.emc-title {
  margin: 0 0 1.5rem 0;
  font-weight: 700;
  font-size: clamp(1.85rem, 3.2vw, 2.4rem);
  letter-spacing: -0.025em;
  line-height: 1.12;
  color: #0a0a0a;
}

.emc-title-accent {
  background: linear-gradient(135deg, #de3431 0%, #ff6b5a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.emc-body {
  margin: 0;
  font-size: clamp(1rem, 1.1vw, 1.1rem);
  line-height: 1.65;
  color: #4a4a55;
  font-weight: 500;
}

@media (max-width: 960px) {
  .emc-inner {
    grid-template-columns: 1fr;
    row-gap: 2rem;
  }
  .emc-media {
    order: 1;
  }
  .emc-content {
    order: 2;
    max-width: none;
  }
  .emc-image {
    max-height: 360px;
    width: auto;
    max-width: 100%;
    margin: 0 auto;
  }
}

@media (max-width: 600px) {
  .emc {
    padding: clamp(2rem, 7vw, 3rem) clamp(0.75rem, 3.5vw, 1.25rem);
  }
  .emc-image {
    width: 100%;
    max-width: none;
    max-height: none;
    height: auto;
  }
  .emc-title {
    font-size: clamp(1.6rem, 7vw, 2.2rem);
    margin-bottom: 1.25rem;
  }
  .emc-eyebrow {
    margin-bottom: 1.25rem;
    font-size: 0.74rem;
    letter-spacing: 0.18em;
  }
}
